'use client';

import { motion, useInView, useReducedMotion } from 'framer-motion';
import { useRef, useState } from 'react';
import CountUp from 'react-countup';

interface CountUpOnceProps {
  value: number;
  className?: string;
  suffix?: string;
  prefix?: string;
  duration?: number;
}

const format = (n: number) => Math.max(0, n).toLocaleString('ko-KR');

const START_RATIO = 0.9;

export const CountUpOnce = ({
  value,
  className,
  suffix = '',
  prefix = '',
  duration = 1.5,
}: CountUpOnceProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });
  const shouldReduceMotion = useReducedMotion();
  const [isComplete, setIsComplete] = useState(false);

  const startValue = Math.floor(value * START_RATIO);

  if (shouldReduceMotion) {
    return (
      <span ref={ref} className={className}>
        {prefix}
        <span className="tabular-nums">{format(value)}</span>
        {suffix}
      </span>
    );
  }

  return (
    <motion.span
      ref={ref}
      className={className}
      animate={
        isComplete
          ? {
              scale: [1, 1.08, 1],
              transition: { duration: 0.3, ease: [0.34, 1.56, 0.64, 1] },
            }
          : {}
      }
    >
      {prefix}
      <span className="tabular-nums">
        {isInView ? (
          <CountUp
            start={startValue}
            end={value}
            duration={duration}
            formattingFn={format}
            onEnd={() => setIsComplete(true)}
          />
        ) : (
          format(startValue)
        )}
      </span>
      {suffix}
    </motion.span>
  );
};
